module.exports = global["$"] = require("-!/Users/kshalm/Dropbox/Physics/Code/Javascript/PhasematchJS/node_modules/expose-loader/index.js?jQuery!/Users/kshalm/Dropbox/Physics/Code/Javascript/PhasematchJS/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js
 ** module id = 304
 ** module chunks = 1
 **/